// context/CartContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(() => {
        if (typeof window === 'undefined') return [];

        try {
            const savedCart = localStorage.getItem('planix_cart');
            return savedCart ? JSON.parse(savedCart) : [];
        } catch (error) {
            console.warn('No se pudo leer el carrito desde localStorage:', error);
            return [];
        }
    });

    const [isCartOpen, setIsCartOpen] = useState(false); // Nuevo estado

    useEffect(() => {
        try {
            localStorage.setItem('planix_cart', JSON.stringify(cart));
        } catch (error) {
            console.warn('No se pudo guardar el carrito en localStorage:', error);
        }
    }, [cart]);

    const addToCart = (plan) => {
        setCart((prev) => {
            if (prev.find((item) => item.id === plan.id)) return prev;
            return [...prev, plan];
        });
        setIsCartOpen(true); // 🔥 Abrimos la "cortina" automáticamente al añadir
    };

    const removeFromCart = (id) => {
        setCart((prev) => prev.filter((item) => item.id !== id));
    };

    const cartTotal = cart.reduce((acc, item) => acc + parseFloat(item.price), 0);

    return (
        <CartContext.Provider value={{
            cart, addToCart, removeFromCart,
            isCartOpen, setIsCartOpen, cartTotal
        }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);